import { useMessageStore } from '~/store/message-store'

export function useAlert() {
  const show = useMessageStore((state) => state.show)
  const close = useMessageStore((state) => state.close)

  return { show, close }
}
